export const getProductImage = (image: string): string => {
  if (process.env.VUE_APP_CLOUDINARY == "true") {
    return image;
  } else {
    return `${process.env.VUE_APP_API_URL}${image}`;
  }
};
